import React, { useContext, useState, useCallback, useMemo, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import { ThemeContext } from "../../../../pages/Homepage";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Papa from "papaparse";
import {
  Box, TextField, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, List, ListItem, ListItemText, ListItemIcon, Typography, Button, Dialog,
  DialogTitle, DialogContent, Tabs, Tab, Slider, CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { getHistoricalData, getVisibleProjectsForMap, getAllProjectsByOrganizationId, saveMapConfiguration, getMapConfiguration, updateProjectVisibilityOne, fetchProjectEnergyData, etchVisibleProjectsDirectly, baseURL, getDeviceTagData, changeselectedproject, getMapHistoricalDataAsync, getPlantViewLabels, savePlantViewLabelSelection } from "../../../../Restclient/datacollection";
import { selectedtreedashboard, updatetabpath, setSelectedStores, updateselecteddates_dashboard, updatetreepathselected, updateselectedpath, updateselectedtreedashboard } from "../../../../store/mainpage_data";
import ReactApexChart from "react-apexcharts";
import CustomButton from "../../../CommonComponents/CustomButton";
import "../../../../cssfiles/Map.css";


const parseCoordinate = (coordString) => {
  if (!coordString) {
    return null;
  }
  if (typeof coordString === 'string') {
    try {
      const degreeRegex = /(\d+\.?\d*)°?\s*([NSEW])?/;
      const match = coordString.match(degreeRegex);
      if (match) {
        const value = parseFloat(match[1]);
        const direction = match[2];
        if (!isNaN(value)) {
          return (direction === 'S' || direction === 'W') ? -value : value;
        }
      }
      const decimal = parseFloat(coordString);
      if (!isNaN(decimal)) {
        return decimal;
      }
    } catch (error) {
      // console.warn('No saved configuration found, using defaults');
      
    }
  }
  if (typeof coordString === 'number' && !isNaN(coordString)) {
    return coordString;
  }
  return null;
};
const buildHierarchicalDataFromProjects = (projects) => {
  const stateGroups = {};
  projects.forEach(project => {
    const address = project.address ||
      (project.ProjectDetails ?
        `${project.ProjectDetails.location}, ${project.ProjectDetails.state}` :
        "Unknown, Unknown");
    const addressParts = address.split(', ');
    const state = addressParts.length > 1 ? addressParts[1] : "Unknown";
    const city = addressParts.length > 0 ? addressParts[0] : "Unknown";
    if (!stateGroups[state]) {
      stateGroups[state] = {};
    }
    if (!stateGroups[state][city]) {
      stateGroups[state][city] = [];
    }
    stateGroups[state][city].push(project);
  });
  const regions = [];
  Object.keys(stateGroups).forEach(state => {
    const circles = [];
    Object.keys(stateGroups[state]).forEach(city => {
      const stores = stateGroups[state][city];
      if (stores.length > 0) {
        circles.push({
          name: city,
          totalStores: stores.length,
          energyConsumption: `${(stores.length * 35000).toLocaleString()} kWh`,
          stores: stores
        });
      }
    });
    if (circles.length > 0) {
      const totalStores = circles.reduce((sum, circle) => sum + circle.totalStores, 0);
      regions.push({
        name: state,
        totalStores: totalStores,
        energyConsumption: `${(totalStores * 35000).toLocaleString()} kWh`,
        circles: circles
      });
    }
  });
  const totalStores = regions.reduce((sum, region) => sum + region.totalStores, 0);
  return {
    enterprise: {
      name: "Project Locations",
      totalStores: totalStores,
      totalEnergyConsumption: `${(totalStores * 35000).toLocaleString()} kWh`,
      regions: regions
    }
  };
};

const INDIA_CAMERA_BOUNDS = {
  west: 66.0,
  south: 5.0,
  east: 95.5,
  north: 37.8,
};

const isIndiaZoomSelection = (value) => {
  const normalizedValue = (value || '').toString().trim().toLowerCase();
  return normalizedValue === '' || normalizedValue === 'india' || normalizedValue === 'all india';
};
export default function MapPage() {
  const layerConfig = useMemo(
    () => ({
      enterprise: {
        color: "#FF5252",
        fillColor: "rgba(255, 82, 82, 0.2)",
        radius: 200000,
        minZoom: 4,
        maxZoom: 6,
        pinSize: 48,
        strokeWidth: 3,
        strokeColor: "#FF1744",
      },
      region: {
        color: "#2196F3",
        fillColor: "rgba(33, 150, 243, 0.2)",
        radius: 150000,
        minZoom: 6,
        maxZoom: 8,
        pinSize: 40,
        strokeWidth: 2,
        strokeColor: "#1976D2",
      },
      circle: {
        color: "#FFC107",
        fillColor: "rgba(255, 193, 7, 0.2)",
        radius: 100000,
        minZoom: 8,
        maxZoom: 10,
        pinSize: 36,
        strokeWidth: 2,
        strokeColor: "#FFA000",
      },
      store: {
        color: "#4CAF50",
        fillColor: "rgba(76, 175, 80, 0.2)",
        radius: 50000,
        minZoom: 10,
        maxZoom: 22,
        pinSize: 32,
        strokeWidth: 2,
        strokeColor: "#388E3C",
      },
    }),
    []
  );

  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedInfo, setSelectedInfo] = useState(null);
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [showComparisonDialog, setShowComparisonDialog] = useState(false);
  const [map, setMap] = useState(null);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [expandedLayers, setExpandedLayers] = useState({});
  const [currentZoomLevel, setCurrentZoomLevel] = useState(4);
  const [timeOfDay, setTimeOfDay] = useState(12);                
  const [activeTab, setActiveTab] = useState(0);
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [deviceTagData, setDeviceTagData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [plantViewMapLabelSelections, setPlantViewMapLabelSelections] = useState([]);
  const [projectLabelSelectionsByProject, setProjectLabelSelectionsByProject] = useState({});
  const mapRef = useRef(null);
  const markersRef = useRef([]);
  const sourcesRef = useRef([]);
  const hasAppliedInitialStateZoomRef = useRef(false);
  const pinRefreshTimerRef = useRef(null);
  const latestProjectTagsByIdRef = useRef({});
  const userCameraLockedRef = useRef(false);
  const isFetchingMapConfigRef = useRef(false);
  const lastMapConfigFetchAtRef = useRef(0);
  const lastVisibleProjectsSignatureRef = useRef('');
  const [comparisonDialogLoading, setComparisonDialogLoading] = useState(false);
  const [comparisonData, setComparisonData] = useState(null);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [projectLocations, setProjectLocations] = useState([]);
  const [projectEnergyData, setProjectEnergyData] = useState({});
  const [last24HourEnergy, setLast24HourEnergy] = useState(0);
  const [selectedProjectData, setSelectedProjectData] = useState({});
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [defaultZoomState, setDefaultZoomState] = useState("");
  const [showDebug, setShowDebug] = useState(false);
  const [hierarchicalData, setHierarchicalData] = useState({
    enterprise: {
      name: "Project Locations",
      totalStores: 0,
      totalEnergyConsumption: "0 kWh",
      regions: [],
    },
  });
  const storeLocations = useMemo(() => {
    if (projectLocations && projectLocations.length > 0) {
      return projectLocations;
    }
    return hierarchicalData.enterprise.regions.flatMap(
      (region) => region.circles.flatMap((circle) => circle.stores)
    );
  }, [projectLocations, hierarchicalData]);
  const projectdata = useSelector((state) => state.logindata.projectdata);
  const organizationData = useSelector((state) => state.logindata.organisationdata);
  useEffect(() => {
  }, [userdetails, organizationData, projectdata]);
//const userDetails = useSelector(state => state.Login.user);
const userDetails = useSelector((state) => state.logindata.userdetails);
const plantjsondata = useSelector((state) => state.logindata.plantjson);

// Add these state declarations if missing:
const [projects, setProjects] = useState([]);
const [filteredProjects, setFilteredProjects] = useState([]);
const [selectedTagsArray, setSelectedTagsArray] = useState([]);
const livedata = useSelector(state => state.mainpagedata.livedata);



  const selectedStoresFromRedux = useSelector((state) => {
    let selectedStores = null;
    if (state?.mainpagedata?.selectedStores) {
      selectedStores = state.mainpagedata.selectedStores;
    } else if (state?.logindata?.selectedStores) {
      selectedStores = state.logindata.selectedStores;
    } else if (state?.mainpage?.selectedStores) {
      selectedStores = state.mainpage.selectedStores;
    }
    if (!selectedStores) {
      selectedStores = [];
    }
    return selectedStores;
  });
  const selectedDates = useSelector((state) => state.mainpagedata?.selecteddates_dashboard || {
    startdates: new Date(),
    enddates: new Date(),
    repstartdates: new Date(),
    rependdates: new Date()
  });
  useEffect(() => {
    setDeviceTagData(null);
  }, [selectedDates.startdates, selectedDates.enddates]);

  // historicalTagData: { [projectId]: { [tagid]: { [aggregation]: value } } }
  // e.g. { "proj1": { "tag123": { "SUM": 4500, "AVG": 187.5 } } }
  const historicalTagDataRef = useRef({});
  const historicalRequestCacheRef = useRef(new Map());
  const historicalInFlightRef = useRef(new Map());
  const historicalFetchSignatureRef = useRef('');
  const [historicalTagDataVersion, setHistoricalTagDataVersion] = useState(0);
  // tracks whether a historical fetch is currently in-flight so markers can show a spinner
  const isHistoricalFetchingRef = useRef(false);
  const [historicalLoadingVersion, setHistoricalLoadingVersion] = useState(0);

  // Fetch historical map values using the globally-selected date range (right-side date picker)
  useEffect(() => {
    if (!Array.isArray(projectLocations) || projectLocations.length === 0) return;

    const orgId = userdetails?.Organizationid;
    const fallbackProjectId = userdetails?.Projectid;
    if (!orgId || !fallbackProjectId) return;

    // Clear stale cache entries so every date-range change fetches fresh data
    historicalRequestCacheRef.current.clear();
    // Reset the signature so the new node always triggers a fresh fetch
    historicalFetchSignatureRef.current = '';
    // Clear stale historical data immediately so markers show the spinner
    // instead of N/A values from the previous node while the new fetch runs
    historicalTagDataRef.current = {};
    isHistoricalFetchingRef.current = true;
    setHistoricalTagDataVersion((v) => v + 1);
    setHistoricalLoadingVersion((v) => v + 1);

    const HISTORICAL_CACHE_TTL_MS = 60000;
    let isCancelled = false;

    // Use Intl.DateTimeFormat with Asia/Kolkata to guarantee the returned
    // YYYY-MM-DD string is always the IST calendar date, regardless of the
    // browser's local system timezone or how the Date was originally created.
    const formatDateIST = (value, fallbackValue) => {
      let base = value ? new Date(value) : (fallbackValue ? new Date(fallbackValue) : new Date());
      if (Number.isNaN(base.getTime())) {
        base = fallbackValue ? new Date(fallbackValue) : new Date();
      }
      // en-CA locale produces YYYY-MM-DD directly
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(base);
    };

    const selectedStart = formatDateIST(
      selectedDates?.startdates,
      new Date(new Date().setDate(new Date().getDate() - 7))
    );
    const selectedEnd = formatDateIST(selectedDates?.enddates, new Date());

    const requestSignatureItems = [];
    for (const location of projectLocations) {
      const projectId = location.projectId || location.id || location.originalId || fallbackProjectId;
      const locationTags = location.selectedTags || location.originalProject?.selectedTags || [];
      for (const tag of locationTags) {
        const normalizedTagId = tag?.tagid || tag?.TagID || tag?.tagId;
        const normalizedDeviceId = tag?.device_id || tag?.deviceId || tag?.DeviceID;
        if (String(tag?.mode || '0') !== '1' || !normalizedTagId || !normalizedDeviceId) continue;
        const tagAggs = tag?.aggregations || tag?.Aggregations;
        const agg = Array.isArray(tagAggs) && tagAggs.length > 0
          ? String(tagAggs[0] || '').trim().toUpperCase()
          : 'SUM';
        // Always use the global date range from the date picker (no per-tag overrides)
        requestSignatureItems.push(`${projectId}|${normalizedTagId}|${normalizedDeviceId}|${selectedStart}|${selectedEnd}|${agg}`);
      }
    }

    requestSignatureItems.sort();
    const fetchSignature = `${orgId}|${requestSignatureItems.join('||')}`;
    if (fetchSignature === historicalFetchSignatureRef.current) {
      return;
    }
    historicalFetchSignatureRef.current = fetchSignature;

    const resolveAggregationValue = (apiData, agg) => {
      if (!apiData) return null;
      const normalizedAgg = String(agg || '').toUpperCase();
      // Prefer backend-cleaned safe display values (filter out meter reset spikes)
      const displayValue         = Number(apiData?.displayValue ?? apiData?.historicalDisplayValue);
      const cleanedTotalValue    = Number(apiData?.cleanedTotalValue);
      const totalValue           = Number(apiData?.totalValue);
      const stats                = apiData.statistics || {};
      const cleanedStats         = apiData.cleanedStatistics || {};
      const points               = Array.isArray(apiData.datapoints) ? apiData.datapoints : [];
      const values               = points.map((p) => Number(p?.value)).filter((v) => Number.isFinite(v));

      // Helper: first finite value wins
      const firstFinite = (...candidates) => {
        for (const v of candidates) {
          if (Number.isFinite(v)) return v;
        }
        return null;
      };

      if (normalizedAgg === 'SUM')  return firstFinite(displayValue, cleanedTotalValue, totalValue, Number(stats.sum));
      if (normalizedAgg === 'AVG')  return firstFinite(Number(cleanedStats.avg), Number(stats.avg));
      if (normalizedAgg === 'MIN')  return firstFinite(Number(cleanedStats.min), Number(stats.min));
      if (normalizedAgg === 'MAX')  return firstFinite(Number(cleanedStats.max), Number(stats.max));
      if (normalizedAgg === 'SVAL') return values.length > 0 ? values[0] : null;
      if (normalizedAgg === 'EVAL') return values.length > 0 ? values[values.length - 1] : null;
      if (normalizedAgg === 'DIFF') {
        const diffFromPoints = values.length >= 2 ? values[values.length - 1] - values[0] : null;
        return firstFinite(displayValue, cleanedTotalValue, totalValue, Number(stats.sum), diffFromPoints);
      }
      return null;
    };

    const fetchHistoricalDataForAllTags = async () => {
      try {
        const historicalDataMap = {};

        for (const location of projectLocations) {
          const projectId = location.projectId || location.id || location.originalId || fallbackProjectId;
          const locationTags = location.selectedTags || location.originalProject?.selectedTags || [];
          const historicalTags = locationTags.filter((tag) => String(tag?.mode || '0') === '1');
          const projectHistoricalData = {};

          for (const tag of historicalTags) {
            const normalizedTagId = tag?.tagid || tag?.TagID || tag?.tagId;
            const normalizedDeviceId = tag?.device_id || tag?.deviceId || tag?.DeviceID;
            if (!normalizedTagId || !normalizedDeviceId) continue;

            const tagAggs = tag?.aggregations || tag?.Aggregations;
            const aggList = Array.isArray(tagAggs) && tagAggs.length > 0
              ? tagAggs.map((agg) => String(agg || '').trim().toUpperCase()).filter(Boolean)
              : ['SUM'];

            // Always use the global IST date range from the date picker
            const startDate = selectedStart;
            const endDate = selectedEnd;

            try {
              const primaryAgg = aggList[0] || 'SUM';
              const needsDatapoints = aggList.some((agg) => agg === 'SVAL' || agg === 'EVAL');
              const requestKey = `${orgId}|${projectId}|${normalizedTagId}|${normalizedDeviceId}|${startDate}|${endDate}|${primaryAgg}`;
              const cached = historicalRequestCacheRef.current.get(requestKey);
              let data;

              if (cached && cached.expiresAt > Date.now()) {
                data = cached.data;
              } else if (historicalInFlightRef.current.has(requestKey)) {
                data = await historicalInFlightRef.current.get(requestKey);
              } else {
                const requestPromise = getMapHistoricalDataAsync(
                  orgId,
                  projectId,
                  normalizedTagId,
                  normalizedDeviceId,
                  startDate,
                  endDate,
                  primaryAgg,
                  {
                    summaryOnly: !needsDatapoints,
                    includeDatapoints: needsDatapoints,
                  }
                )
                  .then((responseData) => {
                    historicalRequestCacheRef.current.set(requestKey, {
                      data: responseData,
                      expiresAt: Date.now() + HISTORICAL_CACHE_TTL_MS,
                    });
                    return responseData;
                  })
                  .finally(() => {
                    historicalInFlightRef.current.delete(requestKey);
                  });

                historicalInFlightRef.current.set(requestKey, requestPromise);
                data = await requestPromise;
              }

              if (isCancelled) {
                return;
              }

              const aggregationValues = {};
              aggList.forEach((agg) => {
                aggregationValues[agg] = resolveAggregationValue(data, agg);
              });

              projectHistoricalData[String(normalizedTagId)] = {
                datapoints: Array.isArray(data?.datapoints) ? data.datapoints : [],
                statistics: data?.statistics || {},
                tagInfo: data?.tagInfo || {},
                parameters: data?.parameters || {},
                aggregations: aggregationValues,
              };
            } catch (error) {
              console.error(`Error fetching historical data for tag ${normalizedTagId}:`, error);
            }
          }

          historicalDataMap[projectId] = projectHistoricalData;
        }

        if (isCancelled) {
          return;
        }
        isHistoricalFetchingRef.current = false;
        historicalTagDataRef.current = historicalDataMap;
        setHistoricalTagDataVersion((v) => v + 1);
      } catch (error) {
        console.error('Error fetching historical data for map:', error);
        isHistoricalFetchingRef.current = false;
        setHistoricalTagDataVersion((v) => v + 1);
      }
    };

    fetchHistoricalDataForAllTags();
    return () => {
      isCancelled = true;
      isHistoricalFetchingRef.current = false;
    };
  }, [projectLocations, selectedDates?.startdates, selectedDates?.enddates, userdetails?.Organizationid, userdetails?.Projectid]);

  useEffect(() => {
    const tagsByProjectId = {};
    (projectLocations || []).forEach((project) => {
      const selectedTags = Array.isArray(project?.selectedTags) ? project.selectedTags : [];
      const keyCandidates = [
        project?.projectId,
        project?.id,
        project?.originalId,
        project?.ProjectID,
        project?.ProjectId,
        project?.originalProject?.ProjectID,
        project?.originalProject?.ProjectId,
        project?.originalProject?.projectID,
        project?.originalProject?.projectId,
      ].filter(Boolean);

      keyCandidates.forEach((key) => {
        tagsByProjectId[String(key)] = selectedTags;
      });
    });

    latestProjectTagsByIdRef.current = tagsByProjectId;
  }, [projectLocations]);

  const hasSelectedStores = useMemo(() =>
    selectedStoresFromRedux && selectedStoresFromRedux.length > 0,
    [selectedStoresFromRedux]
  );
  const getDefaultCoordinatesForLocation = useCallback((state, location) => {
    const defaultCoordinates = {
      'Delhi': [77.1025, 28.7041],
      'Baroda': [73.1812, 22.3072],
      'Vadodara': [73.1812, 22.3072],
      'Mumbai': [72.8777, 19.0760],
      'Bangalore': [77.5946, 12.9716],
      'Chennai': [80.2707, 13.0827],
      'Hyderabad': [78.4867, 17.3850],
      'Kolkata': [88.3639, 22.5726],
      'Ahmedabad': [72.5714, 23.0225],
      'Pune': [73.8567, 18.5204],
      'Jaipur': [75.7873, 26.9124],
      'Lucknow': [80.9462, 26.8467],
      'Kanpur': [80.3319, 26.4499],
      'Nagpur': [79.0882, 21.1458],
      'Indore': [75.8333, 22.7196],
      'Thane': [72.9780, 19.2183],
      'Bhopal': [77.4126, 23.2599],
      'Gujarat': [72.5714, 23.0225],
      'Maharashtra': [75.7139, 19.7515],
      'Karnataka': [75.7139, 15.3173],
      'Tamil Nadu': [78.6569, 11.1271],
      'West Bengal': [87.8550, 22.9868],
      'Rajasthan': [74.2179, 27.0238],
      'Uttar Pradesh': [80.9462, 26.8467],
      'Madhya Pradesh': [78.6569, 22.9734],
      'Telangana': [79.0193, 17.1232],
      'Andhra Pradesh': [79.7400, 15.9129],
      'Lal Kot': [77.1931, 28.5192],
      'Malviya Nagar': [77.2090, 28.5355],
      'M.P. Nagar': [77.4354, 23.2315]
    };
    if (location && defaultCoordinates[location]) {
      return defaultCoordinates[location];
    }
    if (location) {
      const locationKey = Object.keys(defaultCoordinates).find(key =>
        key.toLowerCase() === location.toLowerCase()
      );
      if (locationKey) {
        return defaultCoordinates[locationKey];
      }
    }
    if (state && defaultCoordinates[state]) {
      return defaultCoordinates[state];
    }
    if (state) {
      const stateKey = Object.keys(defaultCoordinates).find(key =>
        key.toLowerCase() === state.toLowerCase()
      );
      if (stateKey) {
        return defaultCoordinates[stateKey];
      }
    }
    return [78.9629, 20.5937];
  }, []);
  const updateDefaultZoomState = useCallback((stateName) => {
    const normalizedStateName = typeof stateName === "string" ? stateName : "";
    setDefaultZoomState((prevState) => {
      hasAppliedInitialStateZoomRef.current = false;
      return normalizedStateName;
    });
  }, []);
  // const focusMapOnIndia = useCallback((mapInstance, duration = 1000) => {
  //   if (!mapInstance) {
  //     return;
  //   }

  //   mapInstance.setCamera({
  //     bounds: INDIA_CAMERA_BOUNDS,
  //     padding: 40,
  //     type: 'fly',
  //     duration,
  //   });
  // }, []);
  const focusMapOnIndia = useCallback((mapInstance, duration = 1000) => {
  if (!mapInstance) return;
  mapInstance.setCamera({
    center: [82.8, 22.5],  // geographic center of India
    zoom: 4.5,             // shows full India comfortably
    type: 'fly',
    duration,
  });
}, []);
  const convertProjectsToMapFormat = useCallback((projects) => {
    if (!projects || !Array.isArray(projects)) {
      return [];
    }
    return projects.map((project, index) => {
      if (!project) {
        return null;
      }
      if (project.ProjectId === 'All' || project.ProjectID === 'All') {
        return null;
      }
      const projectDetails = project.ProjectDetails || project.Projectdetails || {};
      let lat = parseCoordinate(projectDetails.Latitude);
      let lng = parseCoordinate(projectDetails.Longitude);
      const isValidLat = lat !== null && lat >= -90 && lat <= 90;
      const isValidLng = lng !== null && lng >= -180 && lng <= 180;
      const isInIndianRange = isValidLat && isValidLng &&
        lat >= 6 && lat <= 37 &&
        lng >= 68 && lng <= 97;
      let coordinates;
      let coordinateSource = "parsed";
      if (isInIndianRange) {
        coordinates = [lng, lat];
      } else {
        coordinates = getDefaultCoordinatesForLocation(
          projectDetails.State,
          projectDetails.Location
        );
        coordinateSource = "fallback";
        if (coordinateSource === "fallback") {
          const offset = index * 0.001;
          coordinates[0] += offset;
          coordinates[1] += offset;
        }
      }
      const addressParts = [
        projectDetails.Location,
        projectDetails.State,
        projectDetails.Country
      ].filter(Boolean);
      const result = {
        name: project.ProjectName || project.Projectname || project.name || "Unnamed Project",
        id: project.ProjectID || project.ProjectId || project.id,
        originalId: project.ProjectID || project.ProjectId || project.id,
        selectedTags: project.selectedTags || [],
        coordinates: coordinates,
        address: addressParts.join(', ') || "No address available",
        offset: [0, 0],
        _source: "convertProjectsToMapFormat",
        _coordinateSource: coordinateSource,
        ...projectDetails,
        projectDetails: projectDetails,
        originalProject: project
      };
      return result;
    }).filter(Boolean);
  }, [getDefaultCoordinatesForLocation]);
  const calculateBounds = useCallback((coordinates) => {
    if (!coordinates || coordinates.length === 0) {
      return [68.7, 8.4, 97.25, 37.6]; // [west, south, east, north]
    }
    let minLng = coordinates[0][0];
    let minLat = coordinates[0][1];
    let maxLng = coordinates[0][0];
    let maxLat = coordinates[0][1];
    coordinates.forEach(coord => {
      if (coord && Array.isArray(coord) && coord.length >= 2) {
        const lng = coord[0];
        const lat = coord[1];
        if (!isNaN(lng) && !isNaN(lat)) {
          minLng = Math.min(minLng, lng);
          minLat = Math.min(minLat, lat);
          maxLng = Math.max(maxLng, lng);
          maxLat = Math.max(maxLat, lat);
        }
      }
    });
    const padding = 0.1;
    return [
      minLng - padding,
      minLat - padding,
      maxLng + padding,
      maxLat + padding
    ];
  }, []);
  
const createMarkerContent = useCallback(
  (store) => {
    const projectKeyCandidates = [
      store.projectId,
      store.id,
      store.originalId,
      store.originalProject?.ProjectID,
      store.originalProject?.ProjectId,
      store.originalProject?.projectID,
      store.originalProject?.projectId,
    ].filter(Boolean);
    const projectId = projectKeyCandidates[0] || "unknown";

    const displayName = store.name || store.originalProject?.Projectname || "Unknown";
    const selectedTags = Array.isArray(store.selectedTags)
      ? store.selectedTags
      : (latestProjectTagsByIdRef.current[String(projectId)] || []);

    let projectHistData = {};
    for (const key of projectKeyCandidates) {
      if (historicalTagDataRef.current[key]) {
        projectHistData = historicalTagDataRef.current[key];
        break;
      }
    }
    console.log(`Creating marker content for project ${displayName} (ID: ${projectId}) with tags:`, selectedTags);
    const tagData = selectedTags.map((tag) => {
      const normalizedTagId = tag?.tagid || tag?.TagID || tag?.tagId || tag?.id || tag?.key;
      const tagId = normalizedTagId ? String(normalizedTagId) : '';
      const isHistorical = String(tag?.mode || '0') === '1';
      console.log(`Processing tag ${tag.tagname || tag.TagName || tag.std_tagname || 'Unknown Tag'} (ID: ${tagId}) - Mode: ${isHistorical ? 'Historical' : 'Live'}`);
      if (isHistorical) {
        const tagAggs = tag?.aggregations || tag?.Aggregations;
        const primaryAgg = Array.isArray(tagAggs) && tagAggs.length > 0
          ? String(tagAggs[0] || '').trim().toUpperCase()
          : 'SUM';
        const histEntry = projectHistData[tagId] || {};
        const aggregationMap = histEntry?.aggregations || {};
        const normalizedAggEntries = Object.entries(aggregationMap).reduce((acc, [key, value]) => {
          acc[String(key || '').trim().toUpperCase()] = value;
          return acc;
        }, {});
        const valueFromNewShape = normalizedAggEntries[primaryAgg];
        const valueFromLegacyShape = histEntry?.[primaryAgg];
        const value = valueFromNewShape ?? valueFromLegacyShape ?? null;
        // If fetch is still in-flight and no cached value yet, signal loading state
        const isPending = value === null && isHistoricalFetchingRef.current;

        return {
          tagName: `${tag.tagname || tag.TagName || tag.std_tagname || 'Unknown Tag'} [${primaryAgg}]`,
          tagUnit: tag.tagunit || tag.Unit || '',
          value,
          isHistorical: true,
          isPending,
        };
      }

      // Live tag
      const liveDataEntry = Array.isArray(livedata)
        ? livedata.find((item) => {
            const itemTagId = String(
              item?.TagId ?? item?.tagid ?? item?.tagId ?? item?.tagID ?? item?.TagID ?? ''
            ).trim();
            const normalizedTagId = String(tagId || '').trim();
            if (!itemTagId || !normalizedTagId) {
              return false;
            }
            if (itemTagId === normalizedTagId) {
              return true;
            }
            const itemTagAsNumber = Number(itemTagId);
            const tagAsNumber = Number(normalizedTagId);
            return Number.isFinite(itemTagAsNumber) && Number.isFinite(tagAsNumber) && itemTagAsNumber === tagAsNumber;
          })
        : null;
      return {
        tagName: tag.tagname || tag.TagName || tag.std_tagname || 'Unknown Tag',
        tagUnit: tag.tagunit || tag.Unit || '',
        value: liveDataEntry
          ? (liveDataEntry.value ?? liveDataEntry.Value ?? liveDataEntry.val ?? liveDataEntry.y ?? liveDataEntry.currentValue ?? liveDataEntry.tagvalue ?? liveDataEntry.TagValue ?? null)
          : null,
        isHistorical: false,
      };
    });

    let hoverDataContent = '';
    if (selectedTags.length > 0) {
      hoverDataContent += '<div class="marker-hover-data">';

      if (tagData.length > 0) {
        tagData.forEach((tag) => {
          if (tag.isPending) {
            hoverDataContent += `
              <div class="tag-row">
                <span class="tag-name">${tag.tagName}:</span>
                <span class="tag-value"><span class="tag-spinner"></span></span>
              </div>
            `;
          } else {
            const formattedValue = typeof tag.value === 'number'
              ? tag.value.toFixed(2)
              : (tag.value ?? 'N/A');
            hoverDataContent += `
              <div class="tag-row">
                <span class="tag-name">${tag.tagName}:</span>
                <span class="tag-value">${formattedValue} ${tag.tagUnit ? tag.tagUnit : ''}</span>
              </div>
            `;
          }
        });
      } else {
        hoverDataContent += '<div class="no-data-message">No datapoints available</div>';
      }

      hoverDataContent += '</div>';
    }

    const tooltipContent = `<div class="marker-label-title">${displayName}</div>${hoverDataContent}`;

    return `
      <div class="marker-wrapper">
        <div class="marker-pin marker-pin-default"
          onclick="window.handleSchedulerClick(${JSON.stringify({
            ...store,
            projectId: projectId
          }).replace(/"/g, "&quot;")})"
          data-project-id="${projectId}"
        >
          <div class="marker-dot"></div>
        </div>
        
        <div class="marker-label">
          ${tooltipContent}
        </div>
      </div>
    `;
  },
  [livedata, historicalTagDataVersion] // eslint-disable-line react-hooks/exhaustive-deps
);
useEffect(() => {
  if (selectedStoresFromRedux && selectedStoresFromRedux.length > 0) {
    
    selectedStoresFromRedux.forEach(store => {
      const projectId = store.ProjectId || store.id;
      const tagCount = store.selectedTags?.length || 0;
      
      
    });
    
  }
}, [selectedStoresFromRedux]);
useEffect(() => {
  try {
    const hasSelectedStores = Array.isArray(selectedStoresFromRedux) && selectedStoresFromRedux.length > 0;
    
    
    
    const projectsToDisplay = hasSelectedStores ? selectedStoresFromRedux : [];
    
    if (projectsToDisplay && projectsToDisplay.length > 0) {
      const filteredProjects = projectsToDisplay.filter(project => {
        if (!project) return false;
        if (project.ProjectId === 'All' || project.id === 'All') return false;
        return true;
      });
      
      
      
      // Convert to map format - PRESERVE SELECTED TAGS
      const convertedProjects = filteredProjects.map(project => {
        const converted = convertProjectsToMapFormat([project])[0];
        if (converted) {
          // CRITICAL: Attach selected tags to converted project
          converted.selectedTags = project.selectedTags || [];
          
        }
        return converted;
      }).filter(Boolean);
      
      setProjectLocations(convertedProjects);
      
      const hierarchyData = buildHierarchicalDataFromProjects(convertedProjects);
      setHierarchicalData(hierarchyData);
    } else {
      
      setProjectLocations([]);
      setHierarchicalData({
        enterprise: {
          name: "Project Locations",
          totalStores: 0,
          totalEnergyConsumption: "0 kWh",
          regions: [],
        },
      });
    }
  } catch (error) {
    
  }
}, [selectedStoresFromRedux]);
  const updateMapMarkers = useCallback((mapInstance, projects) => {
    try {
      if (!mapInstance || !window.atlas) {
        return;
      }
      if (markersRef.current && markersRef.current.length > 0) {
        markersRef.current.forEach((entry) => {
          const markerInstance = entry?.marker || entry;
          try {
            mapInstance.markers.remove(markerInstance);
          } catch (e) {
          }
        });
        markersRef.current = [];
      }
      if (!projects || !Array.isArray(projects) || projects.length === 0) {
        return;
      }
      const validCoordinates = [];
      let markersAdded = 0;
      projects.forEach((project, index) => {
        if (!project) return;
        if (!project.coordinates || !Array.isArray(project.coordinates) || project.coordinates.length < 2) {
          return;
        }
        const [lng, lat] = project.coordinates;
        if (isNaN(lng) || isNaN(lat)) {
          return;
        }
        validCoordinates.push(project.coordinates);
        const projectId = project.originalProject?.projectID || project.projectId || project.id;
        try {
          const htmlContent = createMarkerContent({
            ...project,
            projectId: projectId,
          });
          const htmlMarker = new window.atlas.HtmlMarker({
            htmlContent: htmlContent,
            position: project.coordinates,
            anchor: 'bottom',
            pixelOffset: [project.offset?.[0] || 0, -10],
          });
          mapInstance.markers.add(htmlMarker);
          markersRef.current.push({
            marker: htmlMarker,
            project: {
              ...project,
              projectId,
            },
          });
          markersAdded++;
        } catch (error) {
        }
      });
      const coordinateStrings = validCoordinates.map(coord => `${coord[0].toFixed(6)},${coord[1].toFixed(6)}`);
      const uniqueCoordinates = new Set(coordinateStrings);

      if (userCameraLockedRef.current) {
        return;
      }

      if (defaultZoomState) {
        const normalizedDefaultState = defaultZoomState.trim().toLowerCase();
        // if (isIndiaZoomSelection(normalizedDefaultState)) {
        //   focusMapOnIndia(mapInstance, 1200);
        //   hasAppliedInitialStateZoomRef.current = true;
        //   return;
        // }
        // This block inside updateMapMarkers — replace bounds with center+zoom too:
if (isIndiaZoomSelection(normalizedDefaultState)) {
  // REPLACE:
  // focusMapOnIndia(mapInstance, 1200);
  // WITH:
  mapInstance.setCamera({
    center: [82.8, 22.5],
    zoom: 4.5,
    type: 'fly',
    duration: 1200,
  });
  hasAppliedInitialStateZoomRef.current = true;
  return;
}

        const stateCoordinates = projects
          .filter((project) => {
            const projectState = (
              project?.projectDetails?.State ||
              project?.State ||
              project?.originalProject?.ProjectDetails?.State ||
              project?.originalProject?.Projectdetails?.State ||
              ''
            ).toString().trim().toLowerCase();

            return projectState !== '' && projectState === normalizedDefaultState;
          })
          .map((project) => project?.coordinates)
          .filter((coord) => Array.isArray(coord) && coord.length >= 2 && !isNaN(coord[0]) && !isNaN(coord[1]));

        if (stateCoordinates.length > 1) {
          const stateBounds = calculateBounds(stateCoordinates);
          mapInstance.setCamera({
            bounds: {
              west: stateBounds[0],
              south: stateBounds[1],
              east: stateBounds[2],
              north: stateBounds[3]
            },
            padding: 90,
            type: 'fly',
            duration: 1200
          });
          hasAppliedInitialStateZoomRef.current = true;
          return;
        }

        if (stateCoordinates.length === 1) {
          mapInstance.setCamera({
            center: stateCoordinates[0],
            zoom: 9.5,
            type: 'fly',
            duration: 1200
          });
          hasAppliedInitialStateZoomRef.current = true;
          return;
        }

        const zoomCenter = getDefaultCoordinatesForLocation(defaultZoomState, defaultZoomState);
        if (Array.isArray(zoomCenter) && zoomCenter.length >= 2) {
          mapInstance.setCamera({
            center: zoomCenter,
            zoom: 8.5,
            type: 'fly',
            duration: 1200
          });
          hasAppliedInitialStateZoomRef.current = true;
          return;
        }
      }

      if (validCoordinates.length > 0) {
        try {
          const bounds = calculateBounds(validCoordinates);
          mapInstance.setCamera({
            bounds: {
              west: bounds[0],
              south: bounds[1],
              east: bounds[2],
              north: bounds[3]
            },
            padding: 50,
            type: 'fly',
            duration: 1500
          });
        } catch (error) {
          if (validCoordinates.length > 0) {
            const firstCoord = validCoordinates[0];
            mapInstance.setCamera({
              center: firstCoord,
              zoom: 6,
              type: 'fly',
              duration: 1000
            });
          }
        }
      } else {
        if (defaultZoomState) {
          const zoomCenter = getDefaultCoordinatesForLocation(defaultZoomState, defaultZoomState);
          if (Array.isArray(zoomCenter) && zoomCenter.length >= 2) {
            mapInstance.setCamera({
              center: zoomCenter,
              zoom: 8.5,
              type: 'fly',
              duration: 1000
            });
            hasAppliedInitialStateZoomRef.current = true;
            return;
          }
        }
        focusMapOnIndia(mapInstance, 1000);
      }
    } catch (error) {
      
    }
  }, [createMarkerContent, calculateBounds, defaultZoomState, getDefaultCoordinatesForLocation]);
  useEffect(() => {
    if (!map || !isMapLoaded || !defaultZoomState || !window.atlas) {
      return;
    }

    const normalizedDefaultState = defaultZoomState.trim().toLowerCase();
    if (isIndiaZoomSelection(normalizedDefaultState)) {
      focusMapOnIndia(map, 1000);
      hasAppliedInitialStateZoomRef.current = true;
      return;
    }

    const stateCoordinates = (projectLocations || [])
      .filter((project) => {
        const projectState = (
          project?.projectDetails?.State ||
          project?.State ||
          project?.originalProject?.ProjectDetails?.State ||
          project?.originalProject?.Projectdetails?.State ||
          ''
        ).toString().trim().toLowerCase();

        return projectState !== '' && projectState === normalizedDefaultState;
      })
      .map((project) => project?.coordinates)
      .filter((coord) => Array.isArray(coord) && coord.length >= 2 && !isNaN(coord[0]) && !isNaN(coord[1]));

    if (stateCoordinates.length > 1) {
      const stateBounds = calculateBounds(stateCoordinates);
      map.setCamera({
        bounds: {
          west: stateBounds[0],
          south: stateBounds[1],
          east: stateBounds[2],
          north: stateBounds[3],
        },
        padding: 90,
        type: 'fly',
        duration: 1000,
      });
      hasAppliedInitialStateZoomRef.current = true;
      return;
    }

    if (stateCoordinates.length === 1) {
      map.setCamera({
        center: stateCoordinates[0],
        zoom: 9.5,
        type: 'fly',
        duration: 1000,
      });
      hasAppliedInitialStateZoomRef.current = true;
      return;
    }

    const zoomCenter = getDefaultCoordinatesForLocation(defaultZoomState, defaultZoomState);
    if (Array.isArray(zoomCenter) && zoomCenter.length >= 2) {
      map.setCamera({
        center: zoomCenter,
        zoom: 8.5,
        type: 'fly',
        duration: 1000,
      });
      hasAppliedInitialStateZoomRef.current = true;
    }
  }, [defaultZoomState, map, isMapLoaded, getDefaultCoordinatesForLocation, projectLocations, calculateBounds, focusMapOnIndia]);
  useEffect(() => {
    const shouldUpdate =
      (Array.isArray(livedata) && livedata.length > 0) ||
      historicalTagDataVersion > 0;
    if (!shouldUpdate) return;
    if (!map || !isMapLoaded || markersRef.current.length === 0) return;

    // Update each marker HTML in-place — avoids remove/re-add which causes flicker
    markersRef.current.forEach(({ marker, project }) => {
      try {
        const newHtml = createMarkerContent(project);
        marker.setOptions({ htmlContent: newHtml });
      } catch (e) {}
    });
  }, [livedata, historicalTagDataVersion, historicalLoadingVersion]); // intentionally minimal deps — createMarkerContent reads refs directly
  const [isRefreshingPins, setIsRefreshingPins] = useState(false);
  const forceCompleteRefresh = useCallback(async () => {
    setIsRefreshingPins(true);
    try {
      if (markersRef.current) {
        markersRef.current.forEach((entry) => {
          const markerInstance = entry?.marker || entry;
          try { map?.markers.remove(markerInstance); } catch (e) { }
        });
        markersRef.current = [];
      }
      setProjectLocations([]);
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (userdetails?.Organizationid) {
        getVisibleProjectsForMap(userdetails.Organizationid, (response) => {
          if (response.success && response.projects?.length > 0) {
            dispatch(setSelectedStores(response.projects));
            const converted = convertProjectsToMapFormat(response.projects);
            setProjectLocations(converted);
            setTimeout(() => {
              setIsRefreshingPins(false);
            }, 1000);
          } else {
            setIsRefreshingPins(false);
          }
        });
      }
    } catch (error) {
      setIsRefreshingPins(false);
    }
  }, [userdetails?.Organizationid, map, dispatch, convertProjectsToMapFormat]);
  const checkPinsAfterLogin = useCallback(() => {
    if (pinRefreshTimerRef.current) {
      clearTimeout(pinRefreshTimerRef.current);
    }
    if (!userdetails?.Organizationid || !map || !isMapLoaded) {
      return;
    }
    const timer = setTimeout(() => {
      const expectedPins = projectdata?.filter(p => p && p.projectID !== 'All').length || 0;
      const actualPins = markersRef.current?.length || 0;
      if (expectedPins > 0 && actualPins === 0) {
        forceCompleteRefresh();
      }
    }, 5000);
    pinRefreshTimerRef.current = timer;
  }, [userdetails?.Organizationid, map, isMapLoaded, projectdata, forceCompleteRefresh]);
  useEffect(() => {
    if (userdetails?.Organizationid && map && isMapLoaded) {
      checkPinsAfterLogin();
    }
    return () => {
      if (pinRefreshTimerRef.current) {
        clearTimeout(pinRefreshTimerRef.current);
        pinRefreshTimerRef.current = null;
      }
    };
  }, [userdetails?.Organizationid, map, isMapLoaded, checkPinsAfterLogin]);
  const EmergencyRefreshButton = () => {
    const expectedPins = projectdata?.filter(p => p && p.projectID !== 'All').length || 0;
    const actualPins = markersRef.current?.length || 0;
    const shouldShow = expectedPins > 0 && actualPins === 0 && !isRefreshingPins;
    if (!shouldShow) return null;
    return (
      <Button
        variant="contained"
        color="error"
        onClick={forceCompleteRefresh}
        disabled={isRefreshingPins}
        className="emergency-refresh-btn"
      >
        {isRefreshingPins ? 'Refreshing...' : 'Refresh Map Pins'}
      </Button>
    );
  };
  const SimpleStatusIndicator = () => {
    const expectedPins = projectdata?.filter(p => p && p.projectID !== 'All').length || 0;
    const actualPins = markersRef.current?.length || 0;
    let status = '';
    let color = '#4CAF50';
    if (isRefreshingPins) {
      status = 'Refreshing pins...';
      color = '#FF9800';
    } else if (expectedPins > 0 && actualPins === 0) {
      status = 'No pins visible';
      color = '#F44336';
    } else if (actualPins > 0) {
      status = `${actualPins} pins visible`;
      color = '#4CAF50';
    } else {
      status = 'No data';
      color = '#757575';
    }
    return (
      <Box className="status-indicator-box" sx={{ borderColor: color }}>
        <Typography variant="caption" sx={{ color, fontWeight: 'bold' }}>
          {status}
        </Typography>
      </Box>
    );
  };
  const ManualRefreshButton = () => (
    <Button
      variant="outlined"
      size="small"
      onClick={forceCompleteRefresh}
      disabled={isRefreshingPins}
      className="manual-refresh-btn"
    >
      {isRefreshingPins ? 'Refreshing...' : 'Force Refresh Pins'}
    </Button>
  );
  useEffect(() => {
    if (selectedStoresFromRedux?.length > 0) {
      setTimeout(() => {
        const actualPins = markersRef.current?.length || 0;
        if (actualPins === 0) {
          forceCompleteRefresh();
        }
      }, 2000);
    }
  }, [selectedStoresFromRedux, forceCompleteRefresh]);
  const handleSchedulerClick = useCallback(
    async (store) => {
      setShowTable(false);
      const projectId = store.projectId ||
        store.originalProject?.projectId ||
        store.id ||
        "unknown";
      if (map && window.atlas) {
        userCameraLockedRef.current = true;
        map.setCamera({
          center: store.coordinates,
          zoom: 15,
          type: 'fly',
          duration: 1000,
        });
        setSelectedInfo({
          type: 'store',
          data: store,
        });
      }
      // if (store.originalProject && projectdata && Array.isArray(projectdata)) {
      //   const clickedProjectName = store.originalProject?.projectname ||
      //     store.name ||
      //     store.originalProject?.name;
      //   const matchingProjectIndex = projectdata.findIndex(project => {
      //     if (!project) return false;
      //     const projectName = project.projectName || project.name || project.Projectname;
      //     return projectName &&
      //       projectName.toLowerCase().trim() === clickedProjectName.toLowerCase().trim();
      //   });
      //   if (matchingProjectIndex !== -1) {
      //     const matchingProject = projectdata[matchingProjectIndex];
      //     const targetProjectId = matchingProject.projectID ||
      //       matchingProject.id ||
      //       matchingProject.ProjectId;
      //     if (targetProjectId) {
      //       dispatch(updateselectedprojectname(targetProjectId));
      //       changeselectedproject(matchingProjectIndex);
            
            // --- NEW: Link saved Plant-View dashboard selections to this project pin click ---
            //console.log(`[Map Pin Click] Clicked project: ${clickedProjectName} (ID: ${targetProjectId})`);
            
            // Find saved plant view label selections for this project from the loaded configuration
            let targetProjectId = store.projectId || store.originalProject?.projectId || store.id || "unknown";
            console.log(`[Map Pin Click] Determined target project ID: ${targetProjectId}`);
            const savedPlantViewEntry = plantViewMapLabelSelections.find(
              entry => String(entry?.projectId || '') === String(targetProjectId || '')
            );
            const targetKey = String(targetProjectId || '');
            const cachedProjectLabelSelected = projectLabelSelectionsByProject?.[targetKey] || {};
            const selectedtreepath = Array.isArray(savedPlantViewEntry?.treePathSelected)
              ? savedPlantViewEntry.treePathSelected
              : (Array.isArray(cachedProjectLabelSelected?.treePathSelected)
                  ? cachedProjectLabelSelected.treePathSelected
                  : []);
            const selectedpath = Array.isArray(savedPlantViewEntry?.selectedPath)
              ? savedPlantViewEntry.selectedPath
              : (Array.isArray(cachedProjectLabelSelected?.selectedPath)
                  ? cachedProjectLabelSelected.selectedPath
                  : []);

            dispatch(updatetreepathselected(selectedtreepath));
            dispatch(updateselectedpath(selectedpath));
            console.log(`[Map Pin Click] Dispatched treepathselected from saved config:`, selectedtreepath);
            console.log(`[Map Pin Click] Dispatched selectedpath from saved config:`, selectedpath);

            if (selectedtreepath.length > 0 && Array.isArray(plantjsondata)) {
              const findNodeByPath = (nodes, pathArr, depth) => {
                if (!Array.isArray(nodes) || depth >= pathArr.length) return null;
                const target = String(pathArr[depth] || '').toLowerCase().trim();
                for (const node of nodes) {
                  if (String(node?.label || '').toLowerCase().trim() === target) {
                    if (depth === pathArr.length - 1) return node;
                    const childFound = findNodeByPath(node?.children || [], pathArr, depth + 1);
                    if (childFound) return childFound;
                  }
                }
                return null;
              };

              let matchedNode = null;
              for (const plant of plantjsondata) {
                const root = plant?.Plantview?.[0];
                if (!root) continue;
                const found = findNodeByPath([root], selectedtreepath, 0);
                if (found) { matchedNode = found; break; }
              }

              if (matchedNode) {
                dispatch(updateselectedtreedashboard({
                  id: matchedNode.id ?? '',
                  name: matchedNode.label ?? '',
                  maindashboardlist: matchedNode.maindashboardlist ?? [],
                  subdashboardlist: matchedNode.subdashboardlist ?? [],
                }));
                console.log(`[Map Pin Click] Dispatched updateselectedtreedashboard for node:`, matchedNode.id, matchedNode.label);
              } else {
                console.warn(`[Map Pin Click] Could not find tree node for path:`, selectedtreepath);
              }
            }
          },
      
    
    
    [map, dispatch, selectedProjectData, isFetchingData, setSelectedInfo, setShowTable, projectdata, plantViewMapLabelSelections, projectLabelSelectionsByProject, userDetails, plantjsondata]
  );
  useEffect(() => {
    window.handleSchedulerClick = handleSchedulerClick;
    return () => {
      delete window.handleSchedulerClick;
    };
  }, [handleSchedulerClick]);


  
  const fetchProjects = () => {
  setIsLoading(true);
  
  try {
    getAllProjectsByOrganizationId(userDetails.Organizationid, (projectsResponse) => {
      
      
      if (projectsResponse.success && projectsResponse.projects) {
        let allProjects = projectsResponse.projects;
        
        // Get configuration
        getMapConfiguration(userDetails.Organizationid, (configResponse) => {
          
          
          let visibilityMap = {};
          let loadedTags = [];
          
          // Initialize all projects as hidden
          allProjects.forEach(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            if (projectId) {
              visibilityMap[projectId] = false;
            }
          });
          
          // Load configuration if available
          if (configResponse.success && configResponse.config && configResponse.config.projectSettings) {
            configResponse.config.projectSettings.forEach(setting => {
              if (setting.projectId) {
                visibilityMap[setting.projectId] = setting.isVisibleOnMap === true;
                
                // Load tags for this project
                if (setting.selectedTags && Array.isArray(setting.selectedTags)) {
                  setting.selectedTags.forEach(tag => {
                    if (tag && tag.projectid && tag.tagid) {
                      loadedTags.push(tag);
                    }
                  });
                }
              }
            });
          }
          
          
          
          // Process projects
          const processedProjects = allProjects.map(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            return {
              ...project,
              isVisibleOnMap: visibilityMap[projectId] === true,
              isVisible: visibilityMap[projectId] === true
            };
          });
          
          setProjects(processedProjects);
          setFilteredProjects(processedProjects);
          
          // Set loaded tags
          if (loadedTags.length > 0) {
            setSelectedTagsArray(loadedTags);
          } else {
            setSelectedTagsArray([]);
          }
          
          // Update Redux
          const visibleProjects = processedProjects.filter(p => p.isVisibleOnMap);
          const visibleProjectsWithTags = visibleProjects.map(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            const projectTags = loadedTags.filter(tag => tag.projectid === projectId);
            
            return {
              ...project,
              selectedTags: projectTags
            };
          });
          
          
          dispatch(setSelectedStores(visibleProjectsWithTags));
          
          setIsLoading(false);
        });
      } else {
        
        setIsLoading(false);
        //showToast('Error', 'Failed to load projects', 'Error');
      }
    });
  } catch (error) {
    
    setIsLoading(false);
    //showToast('Error', `Error loading projects: ${error.message}`, 'Error');
  }
};

const fetchMapConfiguration = useCallback((options = {}) => {
  const { force = false } = options;
  if (!userdetails?.Organizationid) {
    return;
  }

  const now = Date.now();
  if (!force) {
    if (isFetchingMapConfigRef.current) {
      return;
    }
    if (now - lastMapConfigFetchAtRef.current < 4000) {
      return;
    }
  }

  isFetchingMapConfigRef.current = true;
  lastMapConfigFetchAtRef.current = now;
  setIsLoading(true);
  let pendingCallbacks = 2;
  const finalizeFetch = () => {
    pendingCallbacks -= 1;
    if (pendingCallbacks <= 0) {
      isFetchingMapConfigRef.current = false;
      setIsLoading(false);
    }
  };

  const buildVisibleProjectsSignature = (projects) => {
    if (!Array.isArray(projects) || projects.length === 0) {
      return '[]';
    }
    return projects
      .map((project) => {
        const projectId = project?.ProjectID || project?.ProjectId || project?.projectId || project?.id || '';
        const tags = Array.isArray(project?.selectedTags)
          ? project.selectedTags.map((tag) => {
              const tagAggs = Array.isArray(tag?.aggregations)
                ? tag.aggregations.map((agg) => String(agg || '').trim().toUpperCase()).join(',')
                : '';
              return [
                tag?.tagid || '',
                tag?.device_id || '',
                String(tag?.mode || '0'),
                tag?.startDate || '',
                tag?.endDate || '',
                tagAggs,
              ].join(':');
            }).sort().join('|')
          : '';
        return `${projectId}#${tags}`;
      })
      .sort()
      .join('||');
  };

  getMapConfiguration(userdetails.Organizationid, (configResponse) => {
    console.log('Fetched map configuration:', configResponse);
    const configuredState = configResponse?.success
      ? configResponse?.config?.defaultZoomState || ""
      : "";
    updateDefaultZoomState(configuredState);
    
    // Store plant view label selections from config
    if (configResponse?.success && Array.isArray(configResponse?.config?.plantViewMapLabelSelections)) {
      setPlantViewMapLabelSelections(configResponse.config.plantViewMapLabelSelections);
    }
    if (configResponse?.success && configResponse?.config?.projectLabelSelectionsByProject && typeof configResponse.config.projectLabelSelectionsByProject === 'object') {
      setProjectLabelSelectionsByProject(configResponse.config.projectLabelSelectionsByProject);
    }
    
    finalizeFetch();
  });
  
  // Use the new API that gets visible projects WITH their tags
  getVisibleProjectsForMap(userdetails.Organizationid, (apiResponse) => {
    let nextProjects = [];
    if (apiResponse.success && Array.isArray(apiResponse.projects)) {
      nextProjects = apiResponse.projects;
    }

    const nextSignature = buildVisibleProjectsSignature(nextProjects);
    if (nextSignature !== lastVisibleProjectsSignatureRef.current) {
      lastVisibleProjectsSignatureRef.current = nextSignature;
      dispatch(setSelectedStores(nextProjects));
    }

    finalizeFetch();
  });
}, [userdetails?.Organizationid, dispatch, updateDefaultZoomState]);
// Load configuration when component mounts or user changes
useEffect(() => {
  if (userdetails && userdetails.Organizationid) {
    
    fetchMapConfiguration();
  }
}, [userdetails?.Organizationid, fetchMapConfiguration]);  
  useEffect(() => {
    if (map && isMapLoaded) {
      updateMapMarkers(map, projectLocations);
    }
  }, [map, isMapLoaded, projectLocations, updateMapMarkers]);
  const updateProjectVisibility = useCallback((documentId, isVisible) => {
    let actualProjectId = documentId;
    if (projectdata && Array.isArray(projectdata)) {
      const matchingProject = projectdata.find(p => p.id === documentId);
      if (matchingProject && matchingProject.projectId) {
        actualProjectId = matchingProject.projectId;
      }
    }
    if (actualProjectId === documentId && projectLocations && Array.isArray(projectLocations)) {
      const matchingProject = projectLocations.find(p => p.id === documentId);
      if (matchingProject && (matchingProject.projectID || matchingProject.originalProject?.projectId)) {
        actualProjectId = matchingProject.projectID || matchingProject.originalProject.projectId;
      }
    }
    if (actualProjectId === documentId && selectedStoresFromRedux && Array.isArray(selectedStoresFromRedux)) {
      const matchingStore = selectedStoresFromRedux.find(s => s.id === documentId);
      if (matchingStore && matchingStore.projectId) {
        actualProjectId = matchingStore.projectId;
      }
    }
    getMapConfiguration(userdetails.Organizationid, (configResponse) => {
      let config = { projectSettings: [] };
      if (configResponse.success && configResponse.config) {
        config = configResponse.config;
      }
      const existingSettingIndex = config.projectSettings.findIndex(
        setting => setting.projectId === actualProjectId
      );
      if (existingSettingIndex >= 0) {
        config.projectSettings[existingSettingIndex].isVisible = isVisible;
        config.projectSettings[existingSettingIndex].isVisibleOnMap = isVisible;
      } else {
        config.projectSettings.push({
          projectId: actualProjectId,
          isVisible: isVisible,
          isVisibleOnMap: isVisible
        });
      }
      saveMapConfiguration(userdetails.Organizationid, config, (response) => {
        fetchMapConfiguration({ force: true });
      });
    });
  }, [userdetails.Organizationid, fetchMapConfiguration, projectdata, projectLocations, selectedStoresFromRedux]);
  useEffect(() => {
    window.refreshMapConfig = () => {
      if (typeof fetchMapConfiguration === 'function') {
        fetchMapConfiguration({ force: true });
        return true;
      }
      return false;
    };
    window.refreshMapView = (visibleProjects, zoomState) => {
      if (typeof zoomState === 'string') {
        updateDefaultZoomState(zoomState);
      }
      if (map && visibleProjects && Array.isArray(visibleProjects)) {
        const convertedProjects = convertProjectsToMapFormat(visibleProjects);
        setProjectLocations(convertedProjects);
        return true;
      }
      return false;
    };
    return () => {
      if (window.refreshMapConfig) delete window.refreshMapConfig;
      if (window.refreshMapView) delete window.refreshMapView;
    };
  }, [map, convertProjectsToMapFormat, updateMapMarkers, fetchMapConfiguration, updateDefaultZoomState]);

  const loadAzureMapsSDK = () => {
    return new Promise((resolve, reject) => {
      if (window.atlas) {
        resolve(window.atlas);
        return;
      }
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.css";
      link.integrity = "sha384-mfCy2iRZJqzLRDtVlx35dHBPSUpR7yC+BdWapna+x/FFdYoaFKxj+nNzBiarNxNR";
      link.crossOrigin = "anonymous";
      link.type = "text/css";
      document.head.appendChild(link);
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js";
      script.integrity = "sha384-ztWo4KfarMhMe1VioFgkKRIJD1NTYq1As2ufvNYIU+GfcmPvO6+SWucXHn/Q3jNf";
      script.crossOrigin = "anonymous";
      script.onload = () => {
        setTimeout(() => {
          if (window.atlas) {
            resolve(window.atlas);
          } else {
            reject(new Error("Azure Maps SDK loaded but window.atlas is not defined"));
          }
        }, 200);
      };
      script.onerror = (error) => {
        reject(error);
      };
      document.head.appendChild(script);
    });
  };
  useEffect(() => {
    let isSubscribed = true;
    let mapInstance = null;
    const currentHandleSchedulerClick = handleSchedulerClick;
    window.handleSchedulerClick = currentHandleSchedulerClick;
    const initializeMap = async () => {
      if (!isSubscribed || !mapRef.current) return;
      try {
        setIsLoading(true);
        await loadAzureMapsSDK();
        if (!window.atlas) throw new Error("Azure Maps SDK not available");
        // const mapContainer = document.getElementById("myMap");
        // if (mapContainer) {
        //   mapContainer.style.height = "100vh";
        //   mapContainer.style.width = "100%";
        // }
        const mapContainer = document.getElementById("myMap");
// Height and width are now handled by CSS .map-container class
        const defaultLocation = [77.1025, 28.7041]; // Delhi coordinates
        mapInstance = new window.atlas.Map("myMap", {
          center: defaultLocation,
          zoom: 6,
          pitch: 0,
          style: "road",
          language: "en-US",
          authOptions: {
            authType: "subscriptionKey",
            subscriptionKey: "BsVmU0vYD5Dhm5C0kRS6uqSNSNVU7moQfq4LMF8U3lTAFMV1xeMdJQQJ99AKACYeBjF997f3AAAgAZMP1jih",
          },
          view: "IN",
          showLogo: false,
          showFeedbackLink: false,
          preserveDrawingBuffer: true,
          renderWorldCopies: false,
        });
        await new Promise((resolve) => {
          mapInstance.events.add("ready", () => {
            resolve();
          });
        });
        if (!isSubscribed) return;
        mapInstance.controls.add(
          [
            new window.atlas.control.ZoomControl(),
            new window.atlas.control.CompassControl(),
            new window.atlas.control.StyleControl({ mapStyles: ["road", "satellite", "night"] }),
            new window.atlas.control.PitchControl(),
          ],
          { position: "top-right" }
        );
        setMap(mapInstance);
        setIsMapLoaded(true);
        mapInstance.events.add("dragstart", () => {
          userCameraLockedRef.current = true;
        });
        mapInstance.events.add("pitchstart", () => {
          userCameraLockedRef.current = true;
        });
        mapInstance.events.add("rotatestart", () => {
          userCameraLockedRef.current = true;
        });
        mapInstance.events.add("wheel", () => {
          userCameraLockedRef.current = true;
        });
        mapInstance.events.add("zoomend", () => {
          if (mapInstance) {
            setCurrentZoomLevel(Math.floor(mapInstance.getCamera().zoom));
          }
        });
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    initializeMap();
    return () => {
      isSubscribed = false;
      if (mapInstance) {
        markersRef.current.forEach((entry) => {
          const markerInstance = entry?.marker || entry;
          try {
            mapInstance.markers.remove(markerInstance);
          } catch (e) {
          }
        });
        markersRef.current = [];
      }
      if (window.handleSchedulerClick === currentHandleSchedulerClick) {
        delete window.handleSchedulerClick;
      }
    };
  }, []);
  const EnhancedInfoPanel = ({ store, onClose, showStoreData = false }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [deviceTagData, setDeviceTagData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    // const selectedDates = useSelector((state) => state.mainpagedata?.selecteddates_dashboard || {
    //   startdates: new Date(),
    //   enddates: new Date()
    // });
    const selectedDatesRaw = useSelector((state) =>
  state.mainpagedata?.selecteddates_dashboard || {
    startdates: new Date().toISOString(),
    enddates:   new Date().toISOString(),
  }
);
const startEpoch = Math.floor(new Date(selectedDatesRaw.startdates).getTime() / 1000);
const endEpoch   = Math.floor(new Date(selectedDatesRaw.enddates).getTime()   / 1000);
    useEffect(() => {
      if (activeTab === 1 && store?.originalProject?.ProjectId) {
        setDeviceTagData(null);
        setIsLoading(true);
        const projectId = store.originalProject.ProjectId;
        const orgId = store.originalProject.Organizationid || userdetails.Organizationid;
        const startEpoch = Math.floor(selectedDates.startdates.getTime() / 1000);
        const endEpoch = Math.floor(selectedDates.enddates.getTime() / 1000);
        const handleResponse = function (response) {
          if (response.success) {
            setDeviceTagData(response.data);
          } else {
            setDeviceTagData(null);
          }
          setIsLoading(false);
        };
        getDeviceTagData(orgId, projectId, startEpoch, endEpoch, handleResponse);
      }
    }, [activeTab, store, selectedDates.startdates, selectedDates.enddates]);
    const getDisplayFields = () => {
      const projectData = {
        projectName: store.name ||
          store.originalProject?.Projectname ||
          store.originalProject?.name ||
          'N/A',
        location: store.Location ||
          store.originalProject?.Projectdetails?.Location ||
          store.projectDetails?.Location ||
          'N/A',
        state: store.State ||
          store.originalProject?.Projectdetails?.State ||
          store.projectDetails?.State ||
          'N/A',
        country: store.Country ||
          store.originalProject?.Projectdetails?.Country ||
          store.projectDetails?.Country ||
          'N/A',
        latitude: store.Latitude ||
          store.originalProject?.Projectdetails?.Latitude ||
          store.projectDetails?.Latitude ||
          'N/A',
        longitude: store.Longitude ||
          store.originalProject?.Projectdetails?.Longitude ||
          store.projectDetails?.Longitude ||
          'N/A',
        pin: store.Pin ||
          store.originalProject?.Projectdetails?.Pin ||
          store.projectDetails?.Pin ||
          'N/A'
      };
      return [
        { label: 'Project Name', value: projectData.projectName },
        { label: 'Location', value: projectData.location },
        { label: 'State', value: projectData.state },
        { label: 'Country', value: projectData.country },
        { label: 'Latitude', value: projectData.latitude },
        { label: 'Longitude', value: projectData.longitude },
        { label: 'PIN Code', value: projectData.pin }
      ];
    };
    const getStoreTagData = () => {
      const sourceStore = store?.store || store || {};
      const projectKeyCandidates = [
        sourceStore?.projectId,
        sourceStore?.id,
        sourceStore?.originalId,
        sourceStore?.originalProject?.ProjectID,
        sourceStore?.originalProject?.ProjectId,
        sourceStore?.originalProject?.projectID,
        sourceStore?.originalProject?.projectId,
      ].filter(Boolean);
      const storeProjectId = projectKeyCandidates[0];

      let projectHistData = {};
      for (const key of projectKeyCandidates) {
        if (historicalTagDataRef.current[key]) {
          projectHistData = historicalTagDataRef.current[key];
          break;
        }
      }

      const selectedTags = Array.isArray(sourceStore?.selectedTags)
        ? sourceStore.selectedTags
        : (latestProjectTagsByIdRef.current[String(storeProjectId)] || []);
      if (!Array.isArray(selectedTags) || selectedTags.length === 0) {
        return [];
      }

      return selectedTags.map((tag) => {
        const tagId = String(tag?.tagid || tag?.TagID || tag?.tagId || tag?.id || tag?.key || '');
        const isHistorical = String(tag?.mode || '0') === '1';

        if (isHistorical) {
          const tagAggs = tag?.aggregations || tag?.Aggregations;
          const primaryAgg = Array.isArray(tagAggs) && tagAggs.length > 0
            ? String(tagAggs[0] || '').trim().toUpperCase()
            : 'SUM';
          const histEntry = projectHistData[tagId] || {};
          const aggregationMap = histEntry?.aggregations || {};
          const normalizedAggEntries = Object.entries(aggregationMap).reduce((acc, [key, value]) => {
            acc[String(key || '').trim().toUpperCase()] = value;
            return acc;
          }, {});
          const valueFromNewShape = normalizedAggEntries[primaryAgg];
          const valueFromLegacyShape = histEntry?.[primaryAgg];
          const historicalValue = valueFromNewShape ?? valueFromLegacyShape ?? null;

          const liveDataEntry = Array.isArray(livedata)
            ? livedata.find((item) => {
              const itemTagId = String(
                item?.TagId ?? item?.tagid ?? item?.tagId ?? item?.tagID ?? item?.TagID ?? ''
              ).trim();
              const normalizedTagId = String(tagId || '').trim();
              if (!itemTagId || !normalizedTagId) {
                return false;
              }
              if (itemTagId === normalizedTagId) {
                return true;
              }
              const itemTagAsNumber = Number(itemTagId);
              const tagAsNumber = Number(normalizedTagId);
              return Number.isFinite(itemTagAsNumber) && Number.isFinite(tagAsNumber) && itemTagAsNumber === tagAsNumber;
            })
            : null;
          const liveFallbackValue = liveDataEntry
            ? (liveDataEntry.value ?? liveDataEntry.Value ?? liveDataEntry.val ?? liveDataEntry.y ?? liveDataEntry.currentValue ?? liveDataEntry.tagvalue ?? liveDataEntry.TagValue ?? null)
            : null;
          const value = historicalValue ?? liveFallbackValue;

          return {
            tagName: `${tag.tagname || tag.TagName || tag.std_tagname || 'Unknown Tag'} [${primaryAgg}]`,
            tagUnit: tag.tagunit || tag.Unit || '',
            value,
          };
        }

        const liveDataEntry = Array.isArray(livedata)
          ? livedata.find((item) => {
            const itemTagId = String(
              item?.TagId ?? item?.tagid ?? item?.tagId ?? item?.tagID ?? item?.TagID ?? ''
            ).trim();
            const normalizedTagId = String(tagId || '').trim();
            if (!itemTagId || !normalizedTagId) {
              return false;
            }
            if (itemTagId === normalizedTagId) {
              return true;
            }
            const itemTagAsNumber = Number(itemTagId);
            const tagAsNumber = Number(normalizedTagId);
            return Number.isFinite(itemTagAsNumber) && Number.isFinite(tagAsNumber) && itemTagAsNumber === tagAsNumber;
          })
          : null;

        return {
          tagName: tag.tagname || tag.TagName || tag.std_tagname || 'Unknown Tag',
          tagUnit: tag.tagunit || tag.Unit || '',
          value: liveDataEntry
            ? (liveDataEntry.value ?? liveDataEntry.Value ?? liveDataEntry.val ?? liveDataEntry.y ?? liveDataEntry.currentValue ?? liveDataEntry.tagvalue ?? liveDataEntry.TagValue ?? null)
            : null,
        };
      });
    };

    const storeTagData = getStoreTagData();
    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof onClose === 'function') {
        onClose();
      }
    };
    return (
      <Box className="store-info-panels">
        <Paper className="info-panel store-details-panel">
          <Box className="info-panel-header">
            <Typography variant="h6" className="info-panel-title">
              {store.name || store.originalProject?.Projectname || "Unknown Project"}
            </Typography>
          </Box>
          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
          >
            <Tab label="Details" />
          </Tabs>
          <TabPanel value={activeTab} index={0}>
            <List>
              {getDisplayFields().map((field, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={field.label}
                    secondary={field.value}
                    primaryTypographyProps={{
                      fontWeight: 'medium',
                      color: 'text.primary'
                    }}
                    secondaryTypographyProps={{
                      color: 'text.secondary'
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </TabPanel>
        </Paper>

        {showStoreData && (
          <Paper className="store-data-panel" elevation={0}>
            <Typography variant="subtitle1" className="store-data-panel-title">
              Store Data
            </Typography>
            <List dense>
              {storeTagData.length > 0 ? (
                storeTagData.map((tag, index) => {
                  const formattedValue = typeof tag.value === 'number'
                    ? tag.value.toFixed(2)
                    : (tag.value ?? 'N/A');

                  return (
                    <ListItem key={`tag-${index}`} className="store-data-item">
                      <ListItemText
                        primary={tag.tagName}
                        secondary={`${formattedValue} ${tag.tagUnit}`.trim()}
                        primaryTypographyProps={{
                          fontWeight: 'medium',
                          color: '#ffffff'
                        }}
                        secondaryTypographyProps={{
                          color: 'rgba(255,255,255,0.85)'
                        }}
                      />
                    </ListItem>
                  );
                })
              ) : (
                <ListItem className="store-data-item">
                  <ListItemText
                    primary="No datapoints configured for this store"
                    primaryTypographyProps={{
                      color: 'rgba(255,255,255,0.85)'
                    }}
                  />
                </ListItem>
              )}
            </List>
          </Paper>
        )}
      </Box>
    );
  };
  const MapDebugPanel = ({ isVisible, projectLocations, selectedStores, isMapLoaded, map }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [forceRefresh, setForceRefresh] = useState(false);
    if (!isVisible) return null;
    const getProjectInfo = (projectId) => {
      const project = projectLocations.find(p =>
        p.id === projectId || p.ProjectId === projectId || p.originalProject?.ProjectId === projectId
      );
      if (!project && selectedStores) {
        const storeProject = selectedStores.find(p =>
          p.ProjectId === projectId || p.id === projectId
        );
        if (storeProject) {
          return {
            name: storeProject.Projectname || storeProject.name || 'Unknown',
            id: projectId,
            coordinates: storeProject.coordinates || 'Unknown',
            status: 'Found in selectedStores'
          };
        }
      }
      if (project) {
        return {
          name: project.name || 'Unknown',
          id: projectId,
          coordinates: project.coordinates || 'Unknown',
          status: 'Found in projectLocations'
        };
      }
      return { name: 'Not found', id: projectId, status: 'Project not found in any collection' };
    };
    const handleForceUpdate = () => {
      if (!map) return;
      try {
        setForceRefresh(true);
        if (markersRef.current) {
          markersRef.current.forEach((entry) => {
            const markerInstance = entry?.marker || entry;
            try { map.markers.remove(markerInstance); } catch (e) { }
          });
          markersRef.current = [];
        }
        map.setCamera({
          bounds: INDIA_CAMERA_BOUNDS,
          padding: 60
        });
        setTimeout(() => {
          updateMapMarkers(map, projectLocations.length > 0 ? projectLocations : selectedStores);
          setForceRefresh(false);
        }, 500);
      } catch (e) {
        setForceRefresh(false);
      }
    };
    return (
      <Paper className="debug-panel">
        <Typography variant="h6" gutterBottom>Map Debug Panel</Typography>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          className="debug-tabs"
        >
          <Tab label="Status" />
          <Tab label="Projects" />
          <Tab label="Actions" />
        </Tabs>
        {activeTab === 0 && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>Map Status:</Typography>
            <Box className="debug-info-box">
              <Typography variant="body2">
                Map Loaded: <strong>{isMapLoaded ? "Yes" : "No"}</strong><br />
                Map Instance: <strong>{map ? "Available" : "Not Available"}</strong><br />
                Atlas SDK: <strong>{window.atlas ? "Loaded" : "Not Loaded"}</strong><br />
                Project Locations: <strong>{projectLocations?.length || 0}</strong><br />
                Selected Stores: <strong>{selectedStores?.length || 0}</strong>
              </Typography>
            </Box>
            <Typography variant="subtitle2" gutterBottom>Map Container:</Typography>
            <Box className="debug-info-box">
              {document.getElementById("myMap") ? (
                <Typography variant="body2">
                  Width: <strong>{document.getElementById("myMap").offsetWidth}px</strong><br />
                  Height: <strong>{document.getElementById("myMap").offsetHeight}px</strong><br />
                  Visible: <strong>Yes</strong>
                </Typography>
              ) : (
                <Typography variant="body2" color="error">
                  Map container not found in DOM
                </Typography>
              )}
            </Box>
            <Typography variant="subtitle2" gutterBottom>Markers:</Typography>
            <Box className="debug-info-box">
              <Typography variant="body2">
                Active Markers: <strong>{markersRef.current?.length || 0}</strong><br />
                Data Sources: <strong>{sourcesRef.current?.length || 0}</strong>
              </Typography>
            </Box>
          </Box>
        )}
        {activeTab === 1 && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>Project ID Lookup:</Typography>
            <TextField
              size="small"
              placeholder="Enter project ID to lookup"
              fullWidth
              sx={{ mb: 2 }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  const projectInfo = getProjectInfo(e.target.value);
                  alert(`Project: ${projectInfo.name}\nStatus: ${projectInfo.status}\nCoordinates: ${JSON.stringify(projectInfo.coordinates)}`);
                }
              }}
            />
            <Typography variant="subtitle2" gutterBottom>Active Projects:</Typography>
            <Box className="debug-scroll-box">
              {projectLocations && projectLocations.length > 0 ? (
                projectLocations.slice(0, 10).map((project, index) => (
                  <Box key={index} className="debug-list-item">
                    <Typography variant="body2">
                      <strong>{project.name || 'Unnamed'}</strong><br />
                      ID: {project.id || project.ProjectId || project.originalProject?.ProjectId || 'Unknown'}<br />
                      Coordinates: {JSON.stringify(project.coordinates || 'Unknown')}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No project locations available
                </Typography>
              )}
              {projectLocations && projectLocations.length > 10 && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  ...and {projectLocations.length - 10} more projects
                </Typography>
              )}
            </Box>
            <Typography variant="subtitle2" gutterBottom>Selected Stores:</Typography>
            <Box className="debug-scroll-box">
              {selectedStores && selectedStores.length > 0 ? (
                selectedStores.slice(0, 10).map((store, index) => (
                  <Box key={index} className="debug-list-item">
                    <Typography variant="body2">
                      <strong>{store.Projectname || store.name || 'Unnamed'}</strong><br />
                      ID: {store.ProjectId || store.id || 'Unknown'}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No selected stores available
                </Typography>
              )}
              {selectedStores && selectedStores.length > 10 && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  ...and {selectedStores.length - 10} more stores
                </Typography>
              )}
            </Box>
          </Box>
        )}
        {activeTab === 2 && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>Map Actions:</Typography>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              disabled={!map || forceRefresh}
              onClick={handleForceUpdate}
              className="debug-action-btn"
            >
              {forceRefresh ? 'Refreshing...' : 'Force Refresh Map'}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              disabled={!map}
              onClick={() => {
                if (map) {
                  focusMapOnIndia(map, 1000);
                }
              }}
              className="debug-action-btn"
            >
              Reset Map View
            </Button>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={() => {
                try {
                  localStorage.removeItem(`mapConfig_${userdetails.Organizationid}`);
                  alert("Map configuration cache cleared successfully");
                } catch (e) {
                  alert("Error clearing cache: " + e.message);
                }
              }}
              className="debug-action-btn"
            >
              Clear Map Config Cache
            </Button>
            <Button
              variant="outlined"
              color="info"
              fullWidth
              onClick={() => {
                const state = window.__REDUX_DEVTOOLS_EXTENSION__ ?
                  window.__REDUX_DEVTOOLS_EXTENSION__.getState() :
                  'Redux DevTools not available';
                alert("Debug info logged to console");
              }}
            >
              Log Redux State
            </Button>
          </Box>
        )}
      </Paper>
    );
  };
  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box className="tab-panel-box">
            {children}
          </Box>
        )}
      </div>
    );
  };
//   const mapStyle = useMemo(
//     () => ({
//       backgroundColor: theme?.palette?.background?.default || "#ffffff",
//       color: theme?.palette?.text?.primary || "#000000",
//     }),
//     [theme]
//   );
  const analytics = useMemo(() => {
    const totalEnergy = storeLocations.reduce(
      (sum, store) =>
        sum + parseFloat(store.energyConsumption?.replace(/[^0-9.]/g, "") || "0"),
      0
    );
    const avgRating = storeLocations.length > 0 ?
      storeLocations.reduce(
        (sum, store) => sum + (store.metrics?.rating || 0),
        0
      ) / storeLocations.length : 0;
    const totalDailySales = storeLocations.reduce(
      (sum, store) =>
        sum + parseInt(store.metrics?.sales?.replace(/[^0-9]/g, "") || "0"),
      0
    );
    return {
      totalEnergy,
      avgRating: avgRating.toFixed(2),
      totalDailySales,
    };
  }, [storeLocations]);
  class EnhancedEnergyForecaster {
    constructor() {
      this.minVal = 0;
      this.maxVal = 1;
    }
    calculateMovingAverage(data, window = 3) {
      const result = [];
      for (let i = 0; i < data.length; i++) {
        const start = Math.max(0, i - window + 1);
        const values = data.slice(start, i + 1);
        const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
        result.push(avg);
      }
      return result;
    }
    predictNextValues(data) {
      const lastValues = data.slice(-3);
      const avg = lastValues.reduce((a, b) => a + b, 0) / lastValues.length;
      const trend =
        (lastValues[lastValues.length - 1] - lastValues[0]) / lastValues.length;
      return [avg + trend, avg + trend * 2].map((val) => Math.max(0, val));
    }
  }
  const handleSearch = useCallback(() => {
    try {
      const normalizeForComparison = (text) => {
        return text.toLowerCase().replace(/\s+/g, " ").trim();
      };
      const searchTerm = normalizeForComparison(searchQuery);
      if (!map || !window.atlas) {
        return;
      }
      const matchingStores = storeLocations.filter((store) => {
        const normalizedName = normalizeForComparison(store.name);
        const normalizedAddress = normalizeForComparison(store.address);
        if (searchTerm === "mp") {
          return (
            normalizedName.includes("m.p") || normalizedName.includes("mp")
          );
        }
        if (searchTerm === "bhopal") {
          return normalizedAddress.includes("bhopal");
        }
        const isNameMatch = normalizedName.includes(searchTerm);
        const isAddressMatch = normalizedAddress.includes(searchTerm);
        return isNameMatch || isAddressMatch;
      });
      if (matchingStores.length > 0) {
        userCameraLockedRef.current = true;
        if (matchingStores.length === 1) {
          map.setCamera({
            center: matchingStores[0].coordinates,
            zoom: 15,
            type: "fly",
            duration: 1000,
          });
        } else {
          const coordinates = matchingStores.map((store) => store.coordinates);
          const lngs = coordinates.map((coord) => coord[0]);
          const lats = coordinates.map((coord) => coord[1]);
          const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;
          const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
          const padding = 0.02;
          const bounds = {
            west: Math.min(...lngs) - padding,
            south: Math.min(...lats) - padding,
            east: Math.max(...lngs) + padding,
            north: Math.max(...lats) + padding,
          };
          const zoomLevel = searchTerm === "bhopal" ? 12 : 13;
          if (searchTerm === "bhopal") {
            map.setCamera({
              center: [centerLng, centerLat],
              zoom: zoomLevel,
              type: "fly",
              duration: 1000,
            });
          } else {
            map.setCamera({
              bounds: bounds,
              padding: {
                top: 50,
                bottom: 50,
                left: 50,
                right: 50,
              },
              type: "fly",
              duration: 1000,
            });
          }
        }
        setSelectedInfo({
          type: "store",
          data: matchingStores[0],
        });
      } else {
      }
    } catch (error) {
    }
  }, [searchQuery, map, storeLocations]);
  const handleStoreClick = useCallback(
    (store, source = 'other') => {
      setShowTable(false);
      if (map && window.atlas) {
        const isLeftNavSource = source === 'left-nav';
        userCameraLockedRef.current = true;
        map.setCamera({
          center: store.coordinates,
          zoom: 15,
          type: isLeftNavSource ? "ease" : "fly",
          duration: isLeftNavSource ? 1400 : 1000,
        });
        setSelectedInfo({
          type: "store",
          data: store,
          source,
        });
      }
    },
    [map]
  );
  const handleLayerClick = useCallback(
    (type, item) => {
      const willExpand = !expandedLayers[type];
      setExpandedLayers((prev) => ({
        ...prev,
        [type]: !prev[type],
      }));
      if (map && window.atlas && willExpand) {
        let stores = [];
        if (type.startsWith("region-")) {
          stores = item.circles.flatMap((circle) => circle.stores);
        }
        else if (type.startsWith("circle-")) {
          stores = item.stores;
        }
        if (stores.length > 0) {
          userCameraLockedRef.current = true;
          const storeCoordinates = stores.map((store) => store.coordinates);
          const centerLat =
            storeCoordinates.reduce((sum, coord) => sum + coord[1], 0) /
            storeCoordinates.length;
          const centerLng =
            storeCoordinates.reduce((sum, coord) => sum + coord[0], 0) /
            storeCoordinates.length;
          let zoomLevel = 10;
          if (stores.length > 5) zoomLevel = 9;
          if (stores.length > 10) zoomLevel = 8;
          map.setCamera({
            center: [centerLng, centerLat],
            zoom: zoomLevel,
            type: "ease",
            duration: 1500,
          });
        }
      }
      setSelectedInfo({
        type,
        data: item,
      });
    },
    [map, expandedLayers]
  );
  const LayerNavigation = useCallback(
    ({
      hierarchicalData,
      expandedLayers,
      handleLayerClick,
      handleStoreClick,
      updateProjectVisibility,
    }) => {
      return (
        <Paper className="layer-navigation-panel" elevation={0}>
          <List component="nav" className="layer-nav-list">
            <ListItem
              button
              onClick={() =>
                handleLayerClick("enterprise", hierarchicalData.enterprise)
              }
            >
              <ListItemText
                primary={hierarchicalData.enterprise.name}
                primaryTypographyProps={{
                  className: "layer-item-enterprise"
                }}
              />
              {expandedLayers["enterprise"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={expandedLayers["enterprise"]} timeout="auto">
              {hierarchicalData.enterprise.regions.map(
                (region, regionIndex) => (
                  <List key={regionIndex} component="div" disablePadding>
                    <ListItem
                      button
                      className="pl-4"
                      onClick={() =>
                        handleLayerClick(`region-${regionIndex}`, region)
                      }
                    >
                      <ListItemText
                        primary={region.name}
                        primaryTypographyProps={{
                          className: "layer-item-region"
                        }}
                      />
                      {expandedLayers[`region-${regionIndex}`] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </ListItem>
                    <Collapse
                      in={expandedLayers[`region-${regionIndex}`]}
                      timeout="auto"
                    >
                      {region.circles.map((circle, circleIndex) => (
                        <List key={circleIndex} component="div" disablePadding>
                          <ListItem
                            button
                            className="pl-6"
                            onClick={() =>
                              handleLayerClick(
                                `circle-${regionIndex}-${circleIndex}`,
                                circle
                              )
                            }
                          >
                            <ListItemText
                              primary={circle.name}
                              primaryTypographyProps={{
                                className: "layer-item-circle"
                              }}
                            />
                            {expandedLayers[`circle-${regionIndex}-${circleIndex}`] ?
                              <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </ListItem>
                          <Collapse
                            in={expandedLayers[`circle-${regionIndex}-${circleIndex}`]}
                            timeout="auto"
                          >
                            {circle.stores.map((store, storeIndex) => (
                              <ListItem
                                key={storeIndex}
                                button
                                className="pl-8"
                                onClick={() => handleStoreClick(store, 'left-nav')}
                              >
                                <ListItemText
                                  primary={store.name}
                                  primaryTypographyProps={{
                                    className: "layer-item-store"
                                  }}
                                />
                              </ListItem>
                            ))}
                          </Collapse>
                        </List>
                      ))}
                    </Collapse>
                  </List>
                )
              )}
            </Collapse>
          </List>
        </Paper>
      );
    },
    [expandedLayers, projectdata, projectLocations, updateProjectVisibility]
  );
  return (
    <Box className="map-wrapper">
      {/* Search Controls */}
      <Box className="search-controls-container">
        <IconButton
          onClick={() => {
            setShowTable((prev) => !prev);
          }}
          className="search-icon-btn"
        >
          <MenuIcon />
        </IconButton>
        <TextField
          placeholder="Search stores or cities..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          size="small"
          className="search-input"
        />
        <IconButton onClick={handleSearch} className="search-icon-btn">
          <SearchIcon />
        </IconButton>
      </Box>
      {/* Map Container */}
      <div
        ref={mapRef}
        id="myMap"
        className="map-container"
      />
      {/* Loading indicator */}
      {isLoading && (
        <Box className="map-loading-overlay">
          <CircularProgress />
        </Box>
      )}
      {/* Layer Navigation */}
      {!showTable && (
        <LayerNavigation
          hierarchicalData={hierarchicalData}
          expandedLayers={expandedLayers}
          handleLayerClick={handleLayerClick}
          handleStoreClick={handleStoreClick}
          updateProjectVisibility={updateProjectVisibility}
        />
      )}
      {/* Info Panel */}
      {selectedInfo?.type === "store" && (
        <EnhancedInfoPanel
          store={selectedInfo.data}
          showStoreData={selectedInfo?.source === 'left-nav'}
          onClose={() => setSelectedInfo(null)}
        />
      )}
      {/* Table View */}
      {showTable && (
        <TableContainer
          component={Paper}
          className="map-table-container"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Store Name</TableCell>
                <TableCell>Address</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {storeLocations.map((store, index) => (
                <TableRow
                  key={index}
                  hover
                  onClick={() => handleStoreClick(store, 'table')}
                  className="table-row-cursor"
                >
                  <TableCell>{store.name}</TableCell>
                  <TableCell>{store.address}</TableCell>
                  <TableCell>{store.energyConsumption}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {/* Analytics Overview */}
      {!selectedInfo && (
        <Box className="analytics-overview">
          <Typography variant="h6">Analytics Overview</Typography>
          <Typography>
            Total Energy: {analytics.totalEnergy.toFixed(2)} kWh
          </Typography>
          <Typography>Average Rating: {analytics.avgRating}⭐</Typography>
          <Typography>
            Daily Sales: ₹{analytics.totalDailySales.toLocaleString()}
          </Typography>
        </Box>
      )}
      {/* Zoom Level Indicator */}
      <Box className="zoom-indicator">
        Zoom Level: {currentZoomLevel}
      </Box>
      <MapDebugPanel
        isVisible={showDebug}
        projectLocations={projectLocations}
        selectedStores={selectedStoresFromRedux}
        isMapLoaded={isMapLoaded}
        map={map}
      />
    </Box>
  );
};
